import ActvityCard from './ActivityCard';
export default ActvityCard;